<template>
    <div class="container-fluid" v-loading="loading">
        <slot :data="slotData"></slot>
    </div>
</template>

<script>
    import Mixins from "./../common/AssessmentMixins"
    export default {
        mounted() {
            this.currentPage = this.initPage;
            this.nextPageAvailable = this.currentPage === 1;

            this.getPageContent();
            if (this.currentPage > 1) this.getQuestionPage();

            prolitEvents.$on('Navigation:next', ev => this.nextPage());
            prolitEvents.$on('Navigation:previous', ev => this.previousPage());
            prolitEvents.$on('Navigation:finish', ev => this.finish());

            prolitEvents.$on('DroppedTask', ev => {
                if (ev.element !== ''){
                    this.answers[ev.element] = ev.value;
                    this.nextPageAvailable = Object.keys(this.answers).length === 10;
                }
            });

            prolitEvents.$on("QuestionReset", ev =>{
                // console.log(ev);
                this.nextPageAvailable = false;
                delete this.answers[ev];
            });
        },
        mixins:[Mixins],
        data() {
            return {
                currentPage: 1,
                contentPage: {
                    title: '',
                    body: '',
                    image: ''
                },
                loading: false,
                questions: [],
                answers: {},
                updating: false,
                nextPageAvailable: false,
            }
        },
        watch:{
            answers:{
                deep:true,
                handler(newVal){
                    console.log(newVal);
                }
            },

        },
        computed: {
            slotData() {
                return {
                    currentPage: this.currentPage,
                    contentPage: this.contentPage,
                    nextPageAvailable: this.nextPageAvailable,
                    questions: this.questions,
                    loading: this.loading,
                }
            },
            routes() {
                return {
                    assessments: window.App.routes.web.assessment,
                    pages: window.App.routes.api.skills_pages,
                    questions: window.App.routes.api.skills_questions,
                    store: window.App.routes.api.skills_answers_store,
                    update: window.App.routes.api.skills_answers_update,
                    finish: window.App.routes.api.assessments_finish.replace("SLUG",this.assessment.slug),
                };
            }
        },
        methods: {
            getPageContent() {
                this.loading = true;
                axios.get(this.routes.pages.replace('NUM', this.currentPage)).then(response => {
                    this.contentPage.title = response.data.data.title;
                    this.contentPage.body = response.data.data.body;
                    this.contentPage.image = response.data.data.logo;
                    this.setUrlPageParameter(this.currentPage);
                    this.loading = false;
                }).catch(e => {
                    console.log(e);
                    this.loading = false;
                });
            },
            getQuestionPage() {
                this.questions = [];
                this.loading = true;
                axios.get(this.routes.questions.replace('NUM', 'page=' + (this.currentPage - 1))).then(response => {
                    this.questions = response.data.data;
                    this.loading = false;
                    this.$forceUpdate();
                    this.updating = response.data.data[0].user_answer !== null;

                }).catch(e => {
                    this.loading = false
                    console.log(e)
                });
            },
            nextPage() {
                if(this.currentPage===1){
                    this.setNextPage()
                    return;
                }
                if(this.verifyPageAnswersCompleted()){
                    this.updating? this.updateAnswers() : this.saveAnswers();
                }
            },
            setNextPage(){
                this.currentPage++;
                this.getPageContent();
                if (this.currentPage > 1) this.getQuestionPage();
                this.answers = {};
            },
            verifyPageAnswersCompleted() {
                if (Object.keys(this.answers).length === 10) {
                    return true;
                }
                prolitEvents.$emit('ShowNotAnswered');
                return false;
            },
            saveAnswers(finish) {
                this.loading = true
                axios.post(this.routes.store, {
                    answers:this.answers,
                    last_page:this.currentPage,
                }).then(response => {
                    this.upadating = false;
                    if(finish){
                        axios.post(this.routes.finish).then(response=>{
                            window.location = this.routes.assessments;
                        }).catch(e=>console.log(e));
                    }else{
                        this.loading = false;
                        this.setNextPage();
                    }
                }).catch(e => console.log(e));
            },
            updateAnswers(){
                axios.put(this.routes.update, {answers:this.answers}).then(response => {
                    this.upadating = false;
                    this.setNextPage();
                }).catch(e => console.log(e));
            },
            previousPage() {
                this.currentPage--;
                this.getPageContent();
                if (this.currentPage > 1) this.getQuestionPage();
                this.answers={};
            },
            finish(){
                if(this.verifyPageAnswersCompleted()){
                    this.saveAnswers(true);
                }
            },
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/skills/SkillsPage.vue